import { render, staticRenderFns } from "./CheckinWidget.vue?vue&type=template&id=1a5f3bf6&scoped=true"
import script from "./CheckinWidget.vue?vue&type=script&lang=js"
export * from "./CheckinWidget.vue?vue&type=script&lang=js"
import style0 from "./CheckinWidget.vue?vue&type=style&index=0&id=1a5f3bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f3bf6",
  null
  
)

export default component.exports